<template>
  <div class="notification-pager">
    
    <!-- back to latest -->
    <div class="buttons is-centered">
      <b-button v-if="value" @click="$emit('input', null)" :loading="loading" type="is-dark is-outlined" rounded>
        <font-awesome-icon icon="chevron-up" class="mr-2"/>
        Back to the Top
        <font-awesome-icon icon="chevron-up" class="ml-2"/>
      </b-button>
    </div>
    <!-- eo:back to latest -->

    <slot/>

    <!-- load more -->
    <div v-if="hasMore" class="buttons is-centered">
      <b-button @click="loadMore" :loading="loading" type="is-dark is-outlined" rounded>
        <font-awesome-icon icon="chevron-down" class="mr-2"/>
        Load More
        <font-awesome-icon icon="chevron-down" class="ml-2"/>
      </b-button>
    </div>
    <!-- eo:load more -->

  </div>
</template>

<script>
import { jumpToTop } from '@/services/browser/automate'

export default {
  emits: ['input'],
  props: {
    value: Array,
    loading: Boolean,
    results: Object
  },
  computed: {
    hasMore () {
      if (!this.results) return false
      if (!this.results.nextPage) return false
      if (this.results.totalHits === this.results.notifs.length) return false
      return true
    }
  },
  methods: {
    loadMore () {
      this.$emit('input', this.results.nextPage)
      setTimeout(() => jumpToTop(), 300)
    }
  }
}
</script>